import { render, staticRenderFns } from "./echarts-option.vue?vue&type=template&id=a452677c&"
import script from "./echarts-option.vue?vue&type=script&lang=js&"
export * from "./echarts-option.vue?vue&type=script&lang=js&"
import style0 from "./echarts-option.vue?vue&type=style&index=0&id=a452677c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports